import React, { useEffect, useState,useCallback } from "react";
import FormSelect from "../../hook-controls/select";
import { GetListEncrypType } from "../../../module/master/api";
function ComboEncrypType(props) {
  const [Data, setData] = useState([]);
  const GetListcbx = useCallback(
    async () => {
      let data = await GetListEncrypType();
      const cbo= data&&data.map(({ ENCRYPT_NAME: label, ENCRYPT_TYPE_ID: id }) =>({ label, id }));
      setData(cbo);
    },
    [setData],
  )
  useEffect(() => {
    GetListcbx();
  }, [GetListcbx]);
  
  return (
    <>
      <FormSelect {...props} options={Data} />
    </>
  );
}

export default ComboEncrypType;